'use client'

import I18nTranslatorClient from '@/app/_components/Shared/I18nTranslator/I18nTranslatorClient'
import { Button } from '@/app/_primitives/Button'
import Link from 'next/link'

export function ClientLink() {
  return (
    <Button type="button" color="butterScotch" className="mt-24 h-72" asChild>
      <Link
        href="/collabo-v2/XjaWUBVSOPA22ofEinYIW"
        target="_blank"
        className="!text-20 !font-bold !leading-28">
        <I18nTranslatorClient text={'common.suggest_collabo'} />
      </Link>
    </Button>
  )
}
